// auth.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthWebService } from './auth-web.service';
import { IMenusAPIResponse } from '../../models/web/IMenusAPIResponse';
import { ILocalidades } from '../../models/ILocalidades';

@Injectable({
	providedIn: 'root'
})
export class GetMenuWebService {
	private http = inject(HttpClient);
	private authService = inject(AuthWebService);
	token = this.authService.obtenerToken();

	// Autenticación automática al cargar la web

	getMenus(): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<any[]>(`${environment.apiWebUrl}/menus`, { headers });
	}

	// getMenuPrincipal(): Observable<IMenusAPIResponse> {
	// 	const headers = new HttpHeaders({
	// 		Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
	// 		'Content-Type': 'application/json'
	// 	});
	// 	return this.http.get<IMenusAPIResponse>(`${environment.apiWebUrl}/menus/menu-principal`, { headers });
	// }

	// getMenuEnlaces1(): Observable<IMenusAPIResponse> {
	// 	const headers = new HttpHeaders({
	// 		Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
	// 		'Content-Type': 'application/json'
	// 	});
	// 	return this.http.get<IMenusAPIResponse>(`${environment.apiWebUrl}/menus/menu-enlaces`, { headers });
	// }
	// getMenuEnlaces2(): Observable<IMenusAPIResponse> {
	// 	const headers = new HttpHeaders({
	// 		Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
	// 		'Content-Type': 'application/json'
	// 	});
	// 	return this.http.get<IMenusAPIResponse>(`${environment.apiWebUrl}/menus/menu-enlaces-2`, { headers });
	// }
	// getMenuOffcanvasRigth(): Observable<IMenusAPIResponse> {
	// 	const headers = new HttpHeaders({
	// 		Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
	// 		'Content-Type': 'application/json'
	// 	});
	// 	return this.http.get<IMenusAPIResponse>(`${environment.apiWebUrl}/menus/menu-derecha-desktop`, { headers });
	// }

	// getMenuOffcanvasRigth(): Observable<IMenusAPIResponse[]> {
	// 	const headers = new HttpHeaders({
	// 		Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
	// 		'Content-Type': 'application/json'
	// 	});
	// 	return this.http.get<IMenusAPIResponse[]>(`${environment.apiWebUrl}/menus/menu-derecha-desktop`, { headers });
	// }

	getLocalidades(): Observable<ILocalidades[]> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authEcommerceUsername}:${environment.authEcommercePassword}`)
		});
		return this.http.get<ILocalidades[]>(`${environment.apiEcommercebUrl}/Maestro/localidad`, { headers });
	}
}
